// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"index_dropdown_72ug7","icon":"index_icon_24-Kh"};